import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router-dom';
import {
  connect
} from 'react-redux';
import classes from './JsonData.css';
import styles from '../../App.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import api from '../../axios-local-api';
import { FaAngleDown } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';


export class JsonData extends Component {

  constructor() {
    super();
    this.state = { checked: false };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
  }
  componentWillUpdate() {

  }
  componentDidUpdate() {

  }
  handleChange(checked) {
    this.setState({ checked });
  }

  render() {
   
   
      if(!this.props.isDummy){
        return null
      } else {
        return (
          <Box>
            <h3 style={{ paddingRight: 20 }}>JSON Data</h3>
  
            <div className={classes.JsonData}>
            <div className={classes.TitleArea}>
                <div>
                Settings
                </div>
                
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realSettings, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                Wan
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realWan, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                Managed
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realManaged, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                Devices
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realDevices, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                Bandwidth
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realBandwidth, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                DHCP Reservations
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realDhcp, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                DNS
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realDns, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                UPNP
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realUpnp, null, 4)}
              </pre>
              <div className={classes.Separator} />
              <div className={classes.TitleArea}>
                <div>
                Topology Changes
                </div>
              </div>
              <pre className={classes.BodyArea}>
                {JSON.stringify(this.props.realTopology, null, 4)}
              </pre>
              <div className={classes.Separator} />
            
            </div>
          </Box >
        )
      }
      
    
  }
}

const mapStateToProps = (state => {
  return {
    realSettings: state.settings.realSettings,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null, isPinxt: state.auth.pToken !== null,
    realWan: state.wan.realWan,
    realDevices: state.devices.realDevices,
    realBandwidth: state.bandwidth.realBandwidth,
    realManaged: state.managed.realManaged,
    realDhcp: state.dhcp.realDhcp,
    realDns: state.dns.realDns,
    realUpnp: state.upnp.realUpnp,
    realTopology: state.topology.realTopology,
    isDummy:state.auth.isDummy
  };
});

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(JsonData, api));
